import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description ProductsSearch icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { ProductsSearch } from '@sravni/design-system-icons'
 *
 * <ProductsSearch />
 * ```
 */
var ProductsSearch = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "ProductsSearch", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.425 12.399a2.502 2.502 0 0 1-.349 3.828 2.512 2.512 0 0 1-2.838 0 2.502 2.502 0 0 1-.348-3.828 2.499 2.499 0 0 1 3.535 0ZM16.425 15.934 17.99 17.5M7.157 8.333h-2.5c-.92 0-1.667-.745-1.667-1.666v-2.5c0-.921.746-1.667 1.667-1.667h2.5c.92 0 1.667.746 1.667 1.667v2.5c0 .92-.746 1.666-1.667 1.666ZM16.324 8.333h-2.5c-.92 0-1.667-.745-1.667-1.666v-2.5c0-.921.746-1.667 1.667-1.667h2.5c.92 0 1.667.746 1.667 1.667v2.5c0 .92-.746 1.666-1.667 1.666ZM7.157 17.5h-2.5c-.92 0-1.667-.746-1.667-1.667v-2.5c0-.92.746-1.667 1.667-1.667h2.5c.92 0 1.667.746 1.667 1.667v2.5c0 .921-.746 1.667-1.667 1.667Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { ProductsSearch };
//# sourceMappingURL=ProductsSearch.js.map
